import React from 'react';
import { Col } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SelectInputTranslated from 'components/layout/forms/SelectInputTranslated';
import translations from 'services/translations/translations';

import {
  ALU_2K_GLAZY,
  SLIDY_30,
  SLIDY_36,
} from 'components/configurator/types/glazingWallTypes';

import {
  is2kAluGlazy,
  isSlidy30,
  isSlidy36,
} from 'components/configurator/types/glazingWallTypesCheck';

import handleGlassWallProperties from '../handleGlassWallProperties';

import floorProfileTypes, {
  floorProfileTypesByWallTypes,
} from '../../../../types/floorProfileTypes';

const AluGlazyFloorProfile = ({
  disableInputs,
  setChangedFloorProfileType,
}: {
  disableInputs?: boolean;
  setChangedFloorProfileType: (changed: boolean) => void;
}): JSX.Element => {
  const wall = useSelector((state: any) => state.selectedWall.properties);
  const { t } = useTranslation([translations.glassWallProperties]);

  const disableBecauseOfWallType = is2kAluGlazy(wall);

  const getFloorProfileTypeOptions = () => {
    if (is2kAluGlazy(wall)) {
      return floorProfileTypesByWallTypes[ALU_2K_GLAZY];
    }

    if (isSlidy30(wall)) {
      return floorProfileTypesByWallTypes[SLIDY_30];
    }

    if (isSlidy36(wall)) {
      return floorProfileTypesByWallTypes[SLIDY_36];
    }

    return floorProfileTypes;
  };

  const handleFloorProfileType = (e: any) => {
    setChangedFloorProfileType(true);
    handleGlassWallProperties({
      target: {
        name: 'aluGlazyFloorProfileType',
        value: e.target.value,
      },
    });
  };

  const name = 'aluGlazyFloorProfileType';

  return (
    <Col>
      <SelectInputTranslated
        className="edit-fields"
        disabled={disableInputs || disableBecauseOfWallType}
        id={name}
        label={t(`${translations.glassWallProperties}:fields:Floor Profile`)}
        name={name}
        onChange={handleFloorProfileType}
        optionKeyBase={`glass-wall-field-${name}`}
        options={getFloorProfileTypeOptions()}
        required
        value={wall.aluGlazyFloorProfileType}
      />
    </Col>
  );
};

export default AluGlazyFloorProfile;
